import { useMemo } from 'react'

import { createEditor, Editor } from 'slate'
import { withReact } from 'slate-react'

import { PlaceholderType, StructuredText, TextElementType } from '@app/lib/inputs/RichEditor/types'

export const withInlines = (editor: Editor) => {
  const { isInline, isVoid, markableVoid } = editor

  editor.isInline = (element) =>
    ([PlaceholderType.Placeholder] as string[]).includes(element.type) || isInline(element)

  editor.isVoid = (element) => {
    return ([PlaceholderType.Placeholder] as string[]).includes(element.type)
      ? true
      : isVoid(element)
  }

  editor.markableVoid = (element) => {
    return (
      ([PlaceholderType.Placeholder] as string[]).includes(element.type) || markableVoid(element)
    )
  }

  return editor
}

export const defaultEditorValue: StructuredText = [
  {
    type: TextElementType.Paragraph,
    children: [{ text: '' }]
  }
]

export const useSlateEditor = () => {
  const editor = useMemo(() => {
    return withReact(withInlines(createEditor()))
  }, [])

  return {
    editor
  }
}
